module.exports = __webpack_public_path__ + "static/media/patin.a3730e8a.webp";